import {
  ColorPartial,
  PaletteOptions,
} from '@material-ui/core/styles/createPalette'

const Colors: Record<string, ColorPartial> = {
  black: {
    500: '#05050a',
  },
  green: {
    200: '#E5ED9C',
    300: '#D9E36A',
    400: '#C0CF00',
    500: '#BFD02B',
    600: '#BFD107',
  },
  red: {
    100: '#FF3000',
  },
  grey: {
    100: '#F5F2F0',
    200: '#DCD9D8',
    300: '#B2B2B2',
    400: '#767676',
    500: '#acb3c0',
    600: '#404040',
    700: '#262626',
  },

  teal: {
    300: '#D9ECE1',
    400: '#CDE6D7',
    500: '#C0E0CD',
  },
  turquoise: {
    300: '#AADCDB',
    400: '#8DD1CF',
    500: '#29ACE3',
  },
  yellow: {
    500: '#FFED00',
  },
  white: {
    500: '#FFFFFF',
  },
  blue: {
    500: '#29ACE3',
  },
}

const Palette: PaletteOptions = {
  background: {
    default: Colors.white[500],
    grey: Colors.grey[200],
    greyDark: Colors.grey[600],
    greyDarkest: Colors.grey[700],
    light: Colors.grey[100],
    focus: Colors.black[500],
    accent: Colors.green[600],
    accentLight: Colors.green[300],
  },
  button: {
    disabled: Colors.grey[500],
    disabledText: Colors.white[500],
    main: Colors.black[500],
    mainHover: Colors.blue[500],
    mainText: Colors.white[500],
    mainTextHover: Colors.black[500],
    secondary: Colors.grey[100],
    secondaryHover: Colors.grey[100],
    secondaryText: Colors.black[500],
    secondaryTextHover: Colors.black[500],
    tertiary: Colors.green[500],
    tertiaryHover: Colors.green[500],
    tertiaryText: Colors.black[500],
    tertiaryTextHover: Colors.black[500],
    quaternaryHover: Colors.grey[700] + '!important',
  },
  error: {
    light: Colors.grey[100],
    main: Colors.black[500] || '',
    dark: Colors.red[100],
  },
  primary: {
    light: Colors.white[500],
    main: Colors.black[500] || '',
  },
  secondary: {
    light: Colors.turquoise[500],
    main: Colors.yellow[500] || '',
  },
  text: {
    primary: Colors.black[500],
    secondary: Colors.black[500],
    tertiary: Colors.grey[500],
    disabled: Colors.grey[600],
    highlight: Colors.green[500],
    hint: Colors.grey[400],
    input: Colors.black[500],
    invert: Colors.white[500],
    teaser: Colors.grey[600],
  },
}

export default Palette
